import { AlertProps, Box, Flex, Alert as MantineAlert, Text } from '@mantine/core';

type Props = AlertProps & {
    rightSection?: React.ReactNode;
};

export const Alert = ({ rightSection, children, title, color = 'black', ...props }: Props) => {
    return (
        <MantineAlert color={color} variant="filled" {...props}>
            <Flex gap="md" align="center" direction={{ base: 'column', sm: 'row' }}>
                {title && (
                    <Text inherit fw={800} c="white">
                        {title}
                    </Text>
                )}
                <Box style={{ flex: 1 }}>{children}</Box>
                {rightSection && <Box style={{ flex: 0 }}>{rightSection}</Box>}
            </Flex>
        </MantineAlert>
    );
};
